import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { allapiAction } from '../../Redux/common/action';

function Secure()

{
    const router = useNavigate();
    const { id } = useParams();
  
    const dispatch = useDispatch();
  
    //   ltsWRd09eDk27C67ksrtl
  
    // console.log(id);
  
    //   const urlDecod = id.split("ltsWRd09eDk27C67ksrtl");
  
    useEffect(() => {
      // signinSellereSecurite
  
      dispatch(allapiAction.signinSellereSecurite({ userDetails: id }, router));
      return () => {};
    }, []);
  
    useEffect(() => {
      if (localStorage.getItem("access_token")) {
        // setTimeout(() => {
        // deshboard_state?.proCount
        router("/");
        // }, 1000);
      }
    }, []);

  return (
    <div class="d-flex justify-content-center align-items-center vh-100 bg-primary text-white">
        <div class="text-center">
    <div class="spinner-border text-light" role="status" style={{width: '4rem', height: '4rem'}}>
        <span class="visually-hidden">Loading...</span>
    </div>
    <h2 class="mt-3">Loading, please wait...</h2>
</div>
    </div>
  )
}

export default Secure